import { Component, OnInit } from '@angular/core';
import { BaseControlComponent } from "../../../../../../form-controls/components/base-control/base-control.component";
import { ContextInteractionService } from "../../../../../../form-controls/services/context-interaction.service";

@Component({
    selector: 'app-listentry-display-config',
    templateUrl: './listentry-display-config.component.html',
    styleUrls: ['./listentry-display-config.component.scss'],
    standalone: false
})
export class ListEntryDisplayConfigComponent extends BaseControlComponent implements OnInit {
    static componentName = "ListEntryDisplayConfigComponent";

    get buttonText(): string {
        return this.componentData.config.buttonLabel;
    }

    set buttonText(value: string) {
        this.componentData.config.buttonLabel = value;
    }

    constructor(public readonly contextService: ContextInteractionService) {
        super(contextService);
    }

    ngOnInit() {
        if (!this.componentData.config.buttonLabel) {
            this.componentData.config.buttonLabel = "Add to List";
        }
    }

}
